import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/digital-vereint-logo.png'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "context" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const route = useRoute();

const currentRouteName = computed(() => {
  return route.name;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'home' },
            tabIndex: "0"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                alt: "",
                src: _imports_0
              }, null, -1)
            ])),
            _: 1,
            __: [0]
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (currentRouteName.value === 'home')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Wir digitalisieren mit euch das Ehrenamt in Bayern. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  class: "back",
                  to: "/"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" « Zurück zur Startseite ")
                  ])),
                  _: 1,
                  __: [1]
                })
              ]))
        ])
      ])
    ])
  ]))
}
}

})